import React from 'react';

export const TermsConditions: React.FC = () => {
    return (
        <div>
             <h1>Terms and Conditions</h1>
        </div>
    );
}